// extracted by mini-css-extract-plugin
export default {"responsiveimagecontainer":"Placeholder-module--responsiveimagecontainer--4f5e9"};